import { set } from "../../storage/storage";

/**
 *
 * @type {{M_ADD_BASKET_ITEM: string, M_CLEAR_BASKET: string, M_REMOVE_BASKET_ITEM: string}}
 */
export const types = {
  M_ADD_BASKET_ITEM: "M_ADD_BASKET_ITEM",
  M_REMOVE_BASKET_ITEM: "M_REMOVE_BASKET_ITEM",
  M_CLEAR_BASKET: "M_CLEAR_BASKET",
  M_OPEN_BASKET: "M_OPEN_BASKET",
  M_CLOSE_BASKET: "M_CLOSE_BASKET",
  M_TOGGLE_BASKET: "M_TOGGLE_BASKET"
};

/**
 *
 * @type {{PROJECT: string}}
 */
export const ITEM_TYPES = {
  PROJECT: "PROJECT"
};

/**
 *
 * @type {{}}
 */
export const mutations = {
  [types.M_ADD_BASKET_ITEM]: (state, { item, type }) => {
    if (!state.basket.find(a => a.content.uuid === item.uuid))
      state.basket.push({ type, content: item });
    set("basket", state.basket);
  },
  [types.M_REMOVE_BASKET_ITEM]: (state, uuid) => {
    state.basket = state.basket.filter(a => a.content.uuid !== uuid);
    set("basket", state.basket);
  },
  [types.M_CLEAR_BASKET]: state => {
    state.basket = [];
    set("basket", state.basket);
  },
  [types.M_OPEN_BASKET]: state => (state.basketState = true),
  [types.M_CLOSE_BASKET]: state => (state.basketState = false),
  [types.M_TOGGLE_BASKET]: state => (state.basketState = !state.basketState)
};
